import {Component, Input, Output, EventEmitter, ViewChild, OnInit, SimpleChanges, OnChanges} from '@angular/core';
import {EnvService} from "../../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "../../services/auth.service";
import {MicroSelectComponent} from "../../shared/select/micro-select.component";
import {debounceTime} from "rxjs/operators";
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {MicroSelectComboComponent} from "../../shared/select/micro-select-combo.component";

@Component({
  selector: 'micro-site-select',
  templateUrl: './site-select.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: SiteSelectComponent
    }
  ]
})
export class SiteSelectComponent implements OnInit, OnChanges, ControlValueAccessor {

  @ViewChild("sel", {static: true}) sel: MicroSelectComboComponent;

  @Input()
  allLabel: string = 'All';

  @Input()
  placeholder: string = 'Site';

  @Input()
  allSelectOption: boolean = false;

  @Input()
  requiredLabel: string;

  @Input()
  mode: string = 'simple';

  @Output()
  siteIdChange: EventEmitter<any> = new EventEmitter<any>();

  @Input()
  siteId: any;

  @Input()
  regionId: any;

  @Input()
  neId: any;

  @Output()
  valueChange: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  siteChange: EventEmitter<any> = new EventEmitter<any>();

  @Input()
  value: any = '';

  @Input()
  required: boolean = false;

  @Input()
  disabled: boolean = false;

  @Input()
  sizeDynamically: boolean = false;

  @Input()
  jump: boolean = true;

  @Input()
  pickList: boolean = true;

  @Input()
  searchable: boolean = true;

  @Input()
  providedOptions: any[];

  options: any[];

  @Input()
  companyId: any;

  @Input()
  loading: boolean = false;

  @Input()
  valueCallback: any;

  @Input()
  autoSearchableLength: number = 10;

  reloadDebouncer: EventEmitter<any> = new EventEmitter<any>();

  onChange = (siteId) => {};
  onTouched = () => {};

  change(e) {
    let site = undefined;
    if (e) {
      site = this.options?.find(o => o.id === e);
    }
    this.onChange(e);
    this.siteIdChange.emit(e);
    this.siteChange.emit(site);
    this.valueChange.emit(this.sel.getSelectedValue());
  }

  constructor(private auth: AuthService, private env: EnvService, private http: HttpClient) {
  }

  writeValue(siteId: any): void {
    this.siteId = siteId;
  }

  registerOnChange(onChange: any): void {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  ngOnInit(): void {
    this.reloadDebouncer.pipe(debounceTime(10)).subscribe(change => {
      this.reload();
    });
    this.reloadDebounced();
  }

  reloadDebounced() {
    if (!this.providedOptions) this.reloadDebouncer.emit();
  }

  reload() {
    let params: HttpParams = new HttpParams();

    if (this.regionId) {
      params = params.set('regionId', this.regionId);
    }

    if (this.neId) {
      if (this.neId !== '--ANY--') {
        params = params.set('neId', this.neId);
      } else {
        params = params.set('withNes', true);
      }
    }

    if (this.companyId) {
      params = params.set("cId", this.companyId);
    }

    this.loading = true;
    return this.http.get(`${this.env.e.url}/domain/sites/all`, {params: params})
      .subscribe(data => {
        var dataOptions = data as any[];

        if (dataOptions.length && this.allSelectOption) {
          dataOptions.unshift({id: "--ALL--", display: this.allLabel})
        }

        this.options = dataOptions as any[];
        this.loading = false;
      });
  }

  findSite(id) {
    return this.options?.find(o => o.id === id);
  }

  ngOnChanges(changes: SimpleChanges): void {
    let changed = false;
    for (let prop in changes) {
      let change = changes[prop];
      if (prop === 'regionId' || prop === 'companyId' || prop === 'neId') {
        changed = changed || change.currentValue !== change.previousValue;
      } else if (prop === 'siteId' && change.currentValue !== change.previousValue) {
        this.siteId = change.currentValue;
        this.change(change.currentValue);
      }
    }
    if (changed) this.reloadDebounced();
  }
}
